import { EAuthRole } from '@qapline/api';
import { zodStringNullable } from '@qapline/helpers';
import { z } from 'zod';

export const userRoleSchema = z.object({
    userRole_id: z.number(),
    user_id: z.number(),
    role_id: z.number(),
    role: z.object({
        role_id: z.number(),
        name: z.nativeEnum(EAuthRole),
        description: zodStringNullable(),
    }),
});

export const contactInfoSchema = z.object({
    email: z.string().nullable(),
    phone: z.string().nullable(),
    note: z.string().nullable(),
    language: z.object({
        language_id: z.number(),
        languageCode: z.string(),
    }),
});

export const userSchema = z.object({
    user_id: z.number(),
    name: z.string(),
    surname: z.string(),
    email: z.string(),
    number: z.number(),
    tsAdded: z.string(),
    tsLastLogin: zodStringNullable(),
    deleted: z.boolean(),
    tsDeleted: zodStringNullable(),
    profilePicture: zodStringNullable(),
    userRoles: z.array(userRoleSchema),
    contactInfo: contactInfoSchema.nullable(),
});

export type TUser = z.infer<typeof userSchema>;
export type TUserRole = z.infer<typeof userRoleSchema>;
export type TContactInfo = z.infer<typeof contactInfoSchema>;
export * from './api';
